
import React from 'react';
import { plansPageContinueButtonFFlag } from '../utils/globalConfig';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Notification } from '@vds/notifications';

const StyledTextLink = styled.div`
text-decoration: underline;
`
const Space = styled.div`
padding-top: 20px;
`

const RemovePlanNotification = ({ selectedDeviceDetails, devicesAndPlans, isPayGoScenariosWithMonthly }) => {

    const scenariosCheck = plansPageContinueButtonFFlag ? !devicesAndPlans?.payGoOnly && !isPayGoScenariosWithMonthly : devicesAndPlans?.payGoOnly;

    return (
        <>
            {(selectedDeviceDetails?.currentPlanDetails?.filter((plan) => plan?.monthlyITP === true).length > 0) && scenariosCheck &&
                <> <Space />
                    <Notification
                        type="warning"
                        title={<>{devicesAndPlans?.monthlyCurrentPlanText}
                            &nbsp; <StyledTextLink aria-label="removePlan" onClick={() => { window.location.href = devicesAndPlans?.removePlanUrl }}>{devicesAndPlans?.removePlanText}</StyledTextLink>
                        </>}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                        hideCloseButton={true}
                    /> </>
            }
        </>

    )
}
RemovePlanNotification.propTypes = {
    selectedDeviceDetails: PropTypes.object,
    devicesAndPlans: PropTypes.object,
    isPayGoScenariosWithMonthly: PropTypes.bool,
}
export default RemovePlanNotification;